import { graphql } from "@opensea/graphql"
import { itemIdentifierFragment } from "../utils"

export const ItemPreviewTooltipContentFragment = graphql(
  `
    fragment ItemPreviewTooltipContent on ItemIdentifier {
      ...itemIdentifier
    }
  `,
  [itemIdentifierFragment],
)
